import { render, staticRenderFns } from "./AccessRestrictedButton.vue?vue&type=template&id=f26b65a8&scoped=true&"
import script from "./AccessRestrictedButton.vue?vue&type=script&lang=js&"
export * from "./AccessRestrictedButton.vue?vue&type=script&lang=js&"
import style0 from "./AccessRestrictedButton.vue?vue&type=style&index=0&id=f26b65a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26b65a8",
  null
  
)

export default component.exports